import React from 'react';

import moment from 'moment';
import styled from 'styled-components';
import LinkOutStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/link-out-stroke';
import { AlertErrorNotification } from '@ad-scripts/presentation/components/common/alert';

type Props = {
  enabled?: boolean;
  webhookDisabledAt?: string;
};

const AutomaticallyDisabledWebhookErrorBanner = ({ enabled, webhookDisabledAt }: Props): JSX.Element | null => {
  if (enabled || !webhookDisabledAt) {
    return null;
  }

  const automaticallyDisabledDate = moment.utc(webhookDisabledAt);
  const dateString = `${moment.months(automaticallyDisabledDate.month())} ${moment(automaticallyDisabledDate).format(
    'DD, YYYY hh:mm A'
  )} ${automaticallyDisabledDate.zoneAbbr()}`;

  return (
    <div>
      <StyledAlertErrorNotification data-aid="alert-error-notification-disabled-webhook">
        <div>
          <b>Webhook deactivated.</b> This webhook was automatically deactivated on {dateString}.
        </div>
        <div>
          Learn more about why this webhook was turned off by viewing logs below and in the&nbsp;
          <StyledLink
            target="_blank"
            rel="noopener noreferrer"
            href={'https://help.gladly.com/docs/generate-api-tokens-and-create-webhooks'}
          >
            help docs.
            <StyledLinkOutStrokeIcon />
          </StyledLink>
        </div>
      </StyledAlertErrorNotification>
    </div>
  );
};

export default AutomaticallyDisabledWebhookErrorBanner;

const StyledAlertErrorNotification = styled(AlertErrorNotification)`
  min-width: 752px;
  min-height: 74px;
  margin-top: 10px;
  margin-bottom: 24px;
  padding: 18px;
  line-height: 162%;

  svg.exclamationCircleIconContainer {
    margin-top: 4px;
  }
`;

const StyledLink = styled.a`
  display: inline-flex;
  color: inherit;
  text-decoration: underline;
`;

const StyledLinkOutStrokeIcon = styled(LinkOutStrokeIcon)`
  margin-left: 4px;
  margin-top: 2px;
  width: 16px;
  height: 16px;
`;
